import { useAuthStore } from "../stores";
import { Auth } from "../layouts";
import APIs from "../apis";
import useApp from "./app";
import useApi from "./api";

const useAuth = () => {
  const {
    user,
    setUser,
    refreshUser,
    updateProfile,
    logout: logoutStore,
  } = useAuthStore();
  const isAuthenticated = !!user?.uuid;
  const { modal, message } = useApp();
  const { fetch } = useApi();

  const verifyPhone = (phone = "") =>
    new Promise(async (resolve, reject) => {
      try {
        await APIs.auth.sendOtp(phone);
        const codeModal = modal.show({
          title: "Verify Code",
          onClose: reject,
          content: (
            <Auth.OTPVerification
              phone={phone}
              onVerify={async ({ code }: any) => {
                try {
                  const user = await fetch(() =>
                    APIs.auth.verifyOtp({ phone, code }),
                  );
                  setUser({ token: user.token });
                  message.success(
                    !user.alias ? "Welcome!" : `Welcome ${user.alias}!`,
                  );
                  codeModal.destroy();
                  resolve({});
                } catch (error: any) {
                  reject(error);
                }
              }}
            />
          ),
        });
      } catch (error: any) {
        message.error(error.message);
        reject();
      }
    });

  const login = ({ phone = "" } = {}) =>
    !!phone
      ? verifyPhone(phone)
      : new Promise(async (resolve, reject) => {
          const authModal = modal.show({
            title: "Login",
            onClose: reject,
            content: (
              <Auth
                onLogin={async ({ phone }: any) => {
                  try {
                    await verifyPhone(phone);
                    authModal.destroy();
                    resolve({});
                  } catch (error) {
                    reject(error);
                  }
                }}
              />
            ),
          });
        });

  const logout = async () => {
    await logoutStore();
    message.error("You have been logout!");
  };

  return { user, isAuthenticated, login, logout, refreshUser, updateProfile };
};

export default useAuth;
